module.exports = __webpack_public_path__ + "static/media/centro_cancha_1.0e99405b.mp4";